import github from "../imagenes/Iconos/github.svg";
import linkedin from "../imagenes/Iconos/linkedin.svg";
import mail from "../imagenes/Iconos/mail.svg";

const dataIcono = [
  {
    svg: github,
    nombre: "GitHub",
    URL: "https://github.com/SamantaDriuzzi",
    tooltip: "Visita mi perfil en GitHub",
  },
  {
    svg: linkedin,
    nombre: "Linkedin",
    URL: "https://www.linkedin.com/in/samanta-driuzzi/",
    tooltip: "Visita mi perfil en Linkedin",
  },
  {
    svg: mail,
    nombre: "Mail",
    URL: "mailto:driuzzi.samanta.mayra@gmail.com",
    tooltip: "Envíame un correo electrónico",
  },
];
export default dataIcono;
